import { Box } from "@mui/material";
import React, { useLayoutEffect, useState } from "react";
import { PiWarningCircleFill } from "react-icons/pi";
import { Typography, Button, Radio, RadioGroup, FormControlLabel, FormControl } from "@mui/material";
import { IoChevronBack } from "react-icons/io5";
import useModal from "../../hooks/useModel";
import { useLocation, useNavigate } from "react-router-dom";
import { useNavbar } from "../../context/NavBarContext";
import { useFetchPaymentListDataQuery } from "../../api/paymentListPageApi";
import axios from "axios";
import { getHeaders } from "../../utlis/security";

const PurchaseSubscription = () => {
  const location = useLocation();
  const { state } = location;
  console.log('state', state);
  const [Modal, openModal, closeModal] = useModal();
  const navigate = useNavigate();
  const Navbar = useNavbar();
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [modalActions, setModalActions] = useState(null);
  const [modalBody, setModalBody] = useState(null);
  const [selectedPackage, setselectedPackage] = useState("SNS_99S"); // Default to 1 day

  const { data, isLoading } = useFetchPaymentListDataQuery();

  useLayoutEffect(() => {
    Navbar.setToPrevPage(2);
    Navbar.setLogoPlace("Subscription");
    Navbar.setTogglePlace(<IoChevronBack fontSize="20" />);
  }, []);

  const handleFailBtn = () => {
    closeModal();
    setModalActions(null);
    setModalBody(null);
    navigate("/account/purchase_subscription");
  };

  const handlePlanChange = (event) => {
    setselectedPackage(event.target.value);
  };

  const handleBuySubscription = async () => {
    setIsButtonLoading(true);
    
    const payload = {
      udid: "190740e5f0032702",
      phone: JSON.parse(localStorage.getItem("userId")),
      version_code: 29, // this is for development
      version_name: "1.2.9",
      package_id: selectedPackage, // Add the selected payment type
    };
    
    const headers = await getHeaders('purchase_subscription');
    
    try {
      const response = await axios.post(
        "https://apiv2.shwenarsin.com/api/payment/telenor/otp/request",
        payload,
        {headers}
      );
      
      console.log(response);
      
      // Check if OTP was requested successfully
      if (response.data.status == 1) {
        navigate('/audio/subscription/verify', {
          state: { 
                  transId: response.data.trans_id,
                  paymentId: selectedPackage
                }
        });
      } else {
        // Handle other response statuses
        console.log("OTP request failed:", response.data);
        showPaymentFailedModal();
      }
      
      setIsButtonLoading(false);
    } catch (error) {
      console.error("Error:", error);
      setIsButtonLoading(false);
      showPaymentFailedModal();
    }
  };

  // Helper function for payment failed modal
  const showPaymentFailedModal = () => {
    setModalBody(
      <div className="text-center">
        <div className="">
          <PiWarningCircleFill color="#FF0000" size={40} className="inline-block" />
        </div>
        <div className="mt-4">
          <Typography
            variant="body1"
            component="span"
            lineHeight={1}
            fontWeight="bold"
            className="block"
          >
            {/* ငွေပေးချေမှုမအောင်မြင်ပါ */}
            OTP တောင်းဆိုမှုမအောင်မြင်ပါ
          </Typography>
        </div>
      </div>
    );

    setModalActions(
      <div className="flex items-center justify-center ml-10 mr-10 mb-5">
        <Button
          size="small"
          variant="contained"
          onClick={handleFailBtn}
          sx={{
            paddingY: "5px",
            paddingX: "60px",
            borderRadius: "10px",
            backgroundColor: "#facc15",
            color: "black",
            fontWeight: "600",
            "&:hover": {
              backgroundColor: "#eab308",
            },
          }}
        >
          ထပ်ဝယ်ယူမည်
        </Button>
      </div>
    );
    openModal();
  };

  if (isLoading) {
    return <h1>Loading ..</h1>;
  }

  return (
    <Box
      sx={{
        width: 1,
        height: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box sx={{ height: "25%" }}>
        <img
          src={data?.sub_image}
          alt="SNS_GOLD"
          className="w-full h-full"
        />
      </Box>
      
      {/* Radio Button Selection for Subscription Plans */}
      <FormControl component="fieldset" sx={{ mt: 3, mb: 3 }}>
        <RadioGroup
          value={selectedPackage}
          onChange={handlePlanChange}
          name="subscription-plan"
        >
          <FormControlLabel
            value="SNS_99S"
            control={
              <Radio
                sx={{
                  color: "#facc15",
                  '&.Mui-checked': {
                    color: "#facc15",
                  },
                }}
              />
            }
            label={
              <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
                1 ရက် (299 ကျပ် 5% အခွန်ပါပြီး)
              </Typography>
            }
          />
          <FormControlLabel
            value="SNS_525S"
            control={
              <Radio
                sx={{
                  color: "#facc15",
                  '&.Mui-checked': {
                    color: "#facc15",
                  },
                }}
              />
            }
            label={
              <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
                3 ရက် (1050 ကျပ် 5% အခွန်ပါပြီး)
              </Typography>
            }
          />
        </RadioGroup>
      </FormControl>
      
      <Button
        size="small"
        variant="contained"
        disabled={state?.subscription_status === 1 || isButtonLoading}
        disableRipple
        sx={{
          alignSelf: "center",
          marginTop: 3,
          borderRadius: "50px",
          backgroundColor: state?.subscription_status === 1 || isButtonLoading ? "#f3f4f6" : "#facc15",
          color: state?.subscription_status === 1 || isButtonLoading ? "#8b8b8b" : "black",
          "&:hover": {
            backgroundColor: state?.subscription_status === 1 || isButtonLoading ? "#f3f4f6" : "#eab308",
            borderColor: state?.subscription_status === 1 || isButtonLoading ? "#f3f4f6" : "#eab308",
            boxShadow: "none",
          },
          "&:active": {
            boxShadow: "none",
            backgroundColor: state?.subscription_status === 1 || isButtonLoading ? "#f3f4f6" : "#facc15",
            borderColor: state?.subscription_status === 1 || isButtonLoading ? "#f3f4f6" : "#ca8a04",
          },
        }}
        onClick={() => !isButtonLoading && state?.subscription_status !== 1 && handleBuySubscription()}
      >
        {isButtonLoading ? "စောင့်ပါ..." : "ဝန်ဆောင်မှုရယူမည်။"}
      </Button>

      <Modal
        title=""
        body={modalBody}
        actions={modalActions}
      />
    </Box>
  );
};
export default PurchaseSubscription;